export default {
  dialog: {
    title1: "审批记录",
    title2: "帮助",
    title3: "当地岗位服务外包费用结算单",
    title4: "机票费用分割单审批详情",
    title5: "修改外事关系",
    title6: "不良人员",
    title7: "单位",
    title8: "干系人管理",
    title9: "休假天数",
    title10: "休假调整天数",
    title11: "机票历史记录",
    title12: "附件上传",
    title13: "请先选择签证主体",
    title14: "转交审批",
    title15: "上传护照",
    title16: "上传暂住证",
    title17: "修改币种",
    title18: "取消预警",
    title19: "批量设置上级",
    title20: "修改机票",
    title21: "修改费用",
    title22: "奖惩管理",
    title23: "考核及合同续签管理",
    title24: "是否加入现有审批表",
    title25: "费用更新",
  },

  //长名词
  longNoun: {
    backToPreviousPage: "返回上一页",
    title1: "欢迎使用沙特综合管理系统",
    title2: "你好！开启元气满满的一天",
    title3: "登录于",
    title4: "暂无数据",
    title5: "加载中...",
    title6: "审核",
    title7: "审核记录",
    title8: "奖惩管理",
    title9: "当地岗位服务外包单位考核管理",
    title10: "暂无附件",
    title11: "机构资质",
    title12: "票代资源库管理详情",
    title13: "员工劳保档案详情",
    title14: "角色列表",
    title15: "消息类型",
    title16: "全选",
    title17: "全部取消",
    title18: "菜单权限",
    title19: "选择策略",
    title20: "保存策略",
    title21: "菜单配置说明",
    title22:
      "1、如果是用代码生器生成的Vue页面,Url为Vue项目中src->router->viewGrid.js对应表名的path属性",
    title23:
      "2、 如果只是建一级菜单或空菜单url不用填写,【视图/表名】填写.或者/",
    title24: "修改劳保领用周期",
    title25: "外事证照交接记录",
    title26: "外事付费明细汇总成本分割",
    title27: "外事付费明细汇总明细",
    title28: "政务平台详细",
    title29: "HR周报",
    title30: "当地岗位服务费月度挂账明细",
    title31: "外包单位档案管理表单页",
    title32: "人员档案",
    title33: "人员备份档案",
    title34: "费用明细汇总付款单明细",
    title35: "费用明细汇总分割单明细",
    title36: "离职证明",
    title37: "人员撤离申请",
    title38: "我的申请",
    title39: "系统优化意见建议",
    title40: "收入证明",
    title41: "暂住证",
    title42: "请假",
    title43: "加班",
    title44: "护照",
    title45: "工资条",
    title46: "员工岗位变动",
    title47: "工作证明",
    title48: "系统通知",
    title49: "个税清缴",
    title50: "机票变更",
    title51: "机票请购",
    title52: "签证",
    title53: "修改密码",
    ReleaseNews: "发布消息",
    SoFar: "至今为止",
  },

  //筛选和表格公用
  filterTable: {
    processName: "流程名称",
    approvalBusiness: "审批业务",
    businessTable: "业务表",
    businessTableName: "业务表名",
    approvalStatus: "审批状态",
    creator: "创建人",
    creationTime: "创建时间",
    name: "名称",
    name1: "姓名",
    EPIProjectNumber: "项目EPI编号",
    projectDepartmentNumber: "项目部编号",
    projectName: "项目名称",
    projectName1: "项目部",
    ProjectNumber: "项目编号",
    status: "状态",
    code: "代码",
    encoding: "编码",
    enableOrNot: "是否启用",
    jobNature: "岗位性质",
    jobCategory: "岗位类别",
    jobClassification: "岗位分类",
    jobSubcategory: "岗位子分类",
    accountingEntity: "核算主体",
    employeeCode: "员工编码",
    employeeCode1: "员工编号",
    employeeID: "员工ID",
    RegisterID: "登记ID",
    educationLevel: "学历",
    degree: "学位",
    major: "专业",
    graduatedFrom: "毕业院校",
    IDNumber: "身份证号码",
    EmployeeName: "员工姓名",
    PassportNumber: "护照号",
    VisaType: "签证类型",
    RewardAndPenaltyRecord: "奖惩情况",
    RewardAndPunishmentDate: "奖惩日期",
    InformationType: "信息类型",
    IQAMAID: "暂住证号码",
    subProjectName: "分项目名称",
    subProjectName1: "分项目部",
    WorkingUnit: "用工单位",
    department: "部门",
    subDepartment: "二级部门",
    departmentNumber: "部门编号",
    nationality: "国籍",
    LocalEmployer: "当地雇主",
    position: "岗位",
    position1: "岗位名称",
    ProfessionalExpertise: "专业专长",
    dateOfTransfer: "调转日期",
    ApplicationDate: "申请日期",
    employmentForm: "用工形式",
    EstimatedArrivalDate: "拟到岗日期",
    ProjectA: "用工项目",
    ProjectB: "出工项目",
    UnitA: "用工单位",
    UnitB: "出工单位",
    ITMSANo: "借工协议编号",
    DurationOfSupply: "计划借工期限",
    InvoiceCode: "发票代码",
    CostCenterCode: "成本中心代码",
    FeePeriod: "费用期间",
    TOP: "原项目部",
    TOD: "原单位",
    TIP: "调往项目",
    TID: "调往单位",
    ForeignAffairsRelations: "外事关系",
    EvacuationDate: "撤离日期",
    CR: "CR号",
    DispatchCategory: "外派类别",
    RecommendedBy: "引荐项目",
    whetherToVerify: "是否核实",
    FirstParty: "甲方",
    EffectiveDateOfContract: "合同有效日期",
    Remark: "备注",
    ToSecondParty: "乙方",
    IsItBeyondTheGuidancePrice: "是否超出指导价",
    abbreviatedName: "缩写名称",
    WhetherToIncludeApproval: "是否加入审批",
    AgreeOrNot: "是否同意",
    postingDate: "挂账日期",
    organizationalDepartment: "组织部门",
    TrainingCategory: "培训类别",
    TrainingClassName: "培训班名称",
    PlannedDate: "计划日期",
    SubmissionDate: "提交日期",
    CurrentLocation: "当前所在位置",
    TheoreticalNextVacationTime: "理论下次休假时间",
    TheLatestReturnToTheSandTime: "最近一次返沙时间",
    LeaveType: "请假类型",
    ReleaseDate: "发放日期",
    ContractTerminationDate: "合同终止日期",
    usageTime: "使用时间",
    planType: "计划类型",
    ApprovalAndConsentDate: "审批同意日期",
    IsItUrgent: "是否急件",
    WhetherToPay: "是否付费",
    IsItCompleted: "是否办结",
    TemporaryResidencePermitNumberCustomsEntryNumber: "暂住证号/入境号",
    HighlightOrNot: "是否高亮",
    TemporaryResidencePermitValidityPeriod: "暂住证有效期",
    validityPeriodOfTheApprovalDocument: "批件有效期",
    VisaCategory: "签证类别",
    MaterialCollectionStatus: "材料收集情况",
    VisaProcessingStatus: "签证办理状态",
    VisaValidity: "签证有效期",
    VisaValidityStartDate: "签证有效期开始日期",
    WhetherToUploadTheVisa: "是否上传签证",
    IsItAssociatedWithAFlightTicket: "是否关联机票",
    DoesTheVisaDurationCoverTheFlightDuration: "签证时间是否覆盖机票时间",
    HasTheVisaBeenProcessed: "签证是否完成",
    ValidityPeriodOfApprovalDocumentForOverseasMission: "出国任务批件有效期",
    classification: "分类",
    parentsMedicalInsuranceLevel: "父医保等级",
    borderNumber: "海关入境号",
    medicalInsuranceLevel: "医保等级",
    medicalInsuranceStatus: "医保状态",
    JobLevel: "岗位层级",
    PassportValidity: "护照有效期",
    PassportType: "护照类型",
    OldPassport: "旧护照号",
    NewPassport: "新护照号",
    DriversLicenseValidityPeriod: "驾照有效期",
    LicenseNumber: "驾照号",
    LicenseIssueDate: "驾照办理时间",
    ChargedItems: "收费项目",
    ProjectContent: "项目内容",
    Period: "周期",
    TaskNumber: "任务编号",
    WhetherToSummarize: "是否汇总",
    IsTheFeeConfirmed: "费用是否确认",
    BusinessCategory: "业务类别",
    StatisticalDate: "统计日期",
    TicketAgencyName: "票务代理名称",
    MainAgencyAirlines: "主要代理航司",
    CRValidityPeriod: "CR有效期",
    AbbreviationOfTicketingAgent: "票务代理简称",
    oneWayRoundTrip: "单程/往返",
    routeCategory: "航线类别",
    DepartureDate: "起飞日期",
    ArrivalDate: "到达日期",
    ChangeStatus: "变更状态",
    VisaExpirationDate: "签证过期日期",
    DateOfDeparture: "送站日期",
    pickUpDate: "接站日期",
    ticketAgency: "票务代理",
    DateOfIssue: "出票日期",
    WhetherToCreateAnApprovalForm: "是否创建审批单",
    costCenter: "成本中心",
    DepartureCountryRegion: "起飞国家/地区",
    departureCity: "起飞城市",
    ArrivalCountryRegion: "到达国家/地区",
    ArriveInTheCity: "到达城市",
    CountryRegionName: "国家/地区名称",
    IsItARouteCountryregion: "是否航线国家/地区",
    IsItAnAirlineCity: "是否航线城市",
    cityName: "城市名称",
    CountryRegionOfOrigin: "所属国家/地区",
    PeriodCategory: "周期类别",
    flightType: "航班类型",
    DepartureDestinationCountry1: "始发/目的国1",
    DepartureDestinationCountry2: "始发/目的国2",
    TypeOfItinerary: "行程类型",
    initialTrainingRetraining: "初/复训",
    CertificateValidityPeriod: "证书有效期",
    TypeOfInsurance: "投保类型",
    EndDateOfInsuranceLiability: "保险责任结束日期",
    DateOfLoss: "出险日期",
    CategoryOfPhysicalExaminationItems: "体检项目类别",
    PhysicalExaminationValueCategory: "体检值类别",
    PhysicalExaminationDate: "体检日期",
    SNEMECProjectSNEMEC: "中东公司/项目",
    UnitDepartment: "单位/需用部门",
    AuxiliaryMaterialType: "辅助物资类型",
    SafetyMaterialType: "安全物资类型",
    OfficeMaterialType: "内需物资类型",
    RequestPeriod: "需求周期",
    BillDate: "请购日期",
    ForeignAffairsBusinessType: "外事业务类型",
    displayForm: "展现形式",
    CostSummaryAndStatisticsPeriod: "成本汇总统计周期",
    NameofBank: "开户行",
    IBANAccount: "银行账号",
    BankCode: "银行代码",
    BankName: "银行名称",
    ContactPerson: "联系人",
    PhoneNumber: "手机号码",
    EmailAddress: "邮箱",
    annual: "年度",
    quarter: "季度",
    liquidationDate: "清缴日期",
    roleName: "角色名称",
    title: "标题",
    EditableDuringReview: "审核中可编辑",
    UpdateTime: "更新时间",
    Operation: "操作",
    BusinessName: "业务名称",
    CurrentAuditNodeName: "当前审核节点名称",
    No: "序号",
    ChineseName: "中文名",
    EnglishName: "英文名",
    Arabic: "阿拉伯文",
    Abbreviation: "简称",
    ProjectManager: "项目经理",
    ScheduledStartDate: "计划开工日期",
    PlannedDuration: "计划工期",
    ProjectCategory1: "项目类别1",
    ProjectCategory2: "项目类别2",
    initialLevel: "初始级别",
    assessmentResults: "项目完工考核结果",
    Finallevel: "最终级别-兑现",
    stakeholderType: "干系人类别",
    organizationalAttributes: "组织属性",
    registerAddress: "注册地",
    SubcontractingSpecialty: "分包专业",
    legalPerson: "法人代表",
    departmentAttribute: "部门属性",
    SaudiSpecialityName: "沙化分类",
    SubjectClassificationName: "主体分类名称",
    nodeType: "节点类型",
    CompanyName: "单位名称",
    Gender: "性别",
    ResidenceAddress: "户籍地址",
    EntryDate: "入沙时间",
    VisitEndDate: "返沙时间",
    AtLatestEndDate: "最迟返沙时间",
    ExitDate: "离沙时间",
    AtLatestExitDate: "最迟离沙时间",
    ReasonForDeparture: "离境原因",
    updateType: "更新类型",
    updateDetails: "修改详情",
    reverseProject: "调转项目",
    reverseCompany: "调转单位",
    reversePosition: "调转岗位",
    reverseJobClassification: "调转岗位分类&专业",
    reverseStartDate: "调转开始日期",
    reverseEndDate: "调转结束日期",
    requiredQuantity: "需求数量",
    resumeScreeningCount: "简历筛选数",
    NumberOfInterviews: "面试数",
    numberOfHires: "录用数",
    EstimatedArrivalDate: "拟到岗日期",
    proposedUsageCycle: "拟使用周期",
    EditStatus: "编辑状态",
    UsageCycle: "使用周期",
    ITMSANo: "借工协议编号",
    CostCategoryName: "费用项目",
    Amount: "费用金额",
    Amount1: "金额",
    CostDuration: "费用期间",
    InvoiceNumber: "发票号",
    CompanyNameOfBeneficiary: "收款单位",
    flightRoute: "飞行路线",
    evacuationDate: "撤离日期",
    ManpowerSupplier: "外包单位名称",
    OfficeAddress: "办公地址",
    MainCategoryOfManpower: "外派人员主要类别",
    QuantityOfSponsoredEmployee: "自有员工数量",
    RecommendedReason: "推荐原因",
    RecommendedBy: "引荐项目",
    whetherToVerify: "是否核实",
    DateOfTabulation: "创建日期",
    positionNumber: "岗位数量",
    WorkflowTableSN: "表单编号",
    WorkflowTableSN1: "付款通知单编号",
    WorkflowTableSN2: "分割单编号",
    billingMonth: "挂账月份",
    ToSecondPartyAbbreviation: "外包单位简称",
    PaymentMatters: "付款事项",
    AmountWithoutVAT: "发票不含VAT额",
    VATAmount: "增值税额",
    AmountWithVAT: "发票含VAT额",
    MDMSystemSN: "MDM系统编号",
    unitPrice: "单价",
    manHours: "工时数",
    CategoryAndDisciplineName: "岗位系统/专业",
    PositionSystem: "岗位系统",
    PositionSubsystem: "岗位子系统",
    Trainee: "培训对象",
    TrainingFormName: "学习形式",
    ClassHour: "实际课时",
    NumberofTrainees: "培训人数",
    CostEstimation: "费用预估",
    CourseNumber: "培训计划号",
    TrainerNumber: "培训教师编号",
    NameofTeacher: "培训教师姓名",
    TrainingTime: "培训时间",
    OrganizingUnit: "举办单位",
    TrainingCost: "培训费用",
    NumberofTrainees: "培训人次",
    CurrentJobPositionName: "原岗位",
    NewJobPositionName: "新岗位",
    LeaveStartTime: "请假开始时间",
    LeaveEndTime: "请假结束时间",
    NumberOfLeaveDays: "请假天数",
    VacationCycle: "固定休假周期天数",
    ActualLeaveStartTime: "实际休假开始日期",
    ActualLeaveEndTime: "实际休假结束日期",
    ActualLeaveDays: "实际休假天数",
    TheoryLeaveDays: "理论休假天数",
    RemainingLeaveDays: "剩余休假天数",
    NextTheoryLeaveStartTime: "下次理论休假开始日期",
    NextTheoryLeaveEndTime: "下次理论休假结束日期",
    TravelDays: "路程天数",
    RequiredAttendanceDays: "输入应出勤天数",
    ActualAttendanceDays: "输入实际出勤天数",
    TotalNumberOfDaysInSaudiArabia: "输入在沙天数合计",
    NumberOfOvertimeDaysDuringHolidays: "输入假日加班天数",
    OvertimeDaysDuringFestivals: "输入节日加班天数",
    NmberOfPoints: "输入加点个数",
    NormalVacationDays: "输入正常休假天数",
    NumberOfRegularHolidaysAndFestivals: "输入正常休假节假日个数",
    NumberOfDaysOfAbsenceDueToPersonalLeave: "输入事假缺勤天数",
    contingentPayment: "偶然性支付(元)",
    contingentPayment1: "偶然性支付",
    contingencyDeduction: "偶然性扣减",
    PerformanceBonusQuota: "绩效奖金_定额数量",
    PerformanceBonusAndOthers: "绩效奖金_其他金额",
    Date: "日期",
    PerformanceBonusDistributionRatio: "绩效奖金发放比例",
    ActualAttendance: "输入实际出勤",
    ExtraHoursOnWorkingDays: "输入工作日加点数",
    AddPointsDuringHolidays: "输入节假日加点数",
    startDate: "开始日期",
    startDate1: "认证日期",
    endDate: "结束日期",
    ContractUnitName: "合同签署单位",
    ApplyUnitName: "申请单位",
    AmouttoSINOPEC: "中石化员工",
    AmouttoNonSINOPEC: "非中石化员工",
    WorkingPlace: "拟工作地点",
    AarrivalDateatKSA: "计划来沙时间",
    WorkingDuration: "计划在沙工作期限",
    refundQduantity: "退还数量",
    refundAmount: "退还金额",
    RefundReason: "退还原因",
    VariableQuantity: "变动数量",
    NameOfAuthorizedAgent: "授权代理名称",
    PlannedQuantity: "计划数量",
    PurchaseQuantity: "购买数量",
    authorizedQuantity: "授权数量",
    UsageQuantity: "使用数量",
    CancelQuantity: "取消数量",
    AuthorizedQuantityForUse: "已授权可使用数量",
    AuthorizedQuantity: "可授权数量",
    DateOfBirth: "出生日期",
    ApproveDate: "审批日期",
    BusinessRequirementDuration: "业务需求时长",
    IssueDate: "签发日期",
    IssueDate1: "颁发日期",
    PlaceOfIssue: "签发地",
    CompanyNameInEnglish: "公司英文名",
    CompanyCRNO: "营业执照号",
    WorkAbroad: "出国任务",
    VisitCountries: "出访国家(地区)",
    InvitationUnit: "邀请单位",
    VisitDate: "出访时间",
    WorkBasisAndDescription: "出国（境）依据及 事由说明",
    ApplicationTime: "填报日期",
    VisitDays: "天数",
    DeparatureFlight: "出发航班信息",
    ArrivalFlight: "返回航班信息",
    CurrentStatus: "目前状态",
    CompletionTime: "完成时间",
    expirationTime: "到期时间",
    AirTicket: "机票",
    VisaInformation: "签证信息",
    VisaPeriod: "签证时长",
    VisaPeriod1: "签证办理时间",
    AirTicketInformation: "机票信息",
    DepartureTicketTime: "离沙机票时间",
    ReturnTicketTime: "返沙机票时间",
    VisaAnnex: "签证附件",
    Age: "年龄",
    ReligionName: "宗教信仰",
    Cost: "费用",
    InsuranceStartTime: "有效期开始时间",
    InsuranceEndTime: "有效期结束时间",
    BasicSalary: "基本工资",
    HousingAllowance: "住房补贴",
    CareerLevel: "境外职位等级",
    CareerName: "境外职位名称",
    JobOccupationOnIQAMA: "暂住证职位名称",
    IQAMAJobTitleAR: "暂住证职位名称(阿文)",
    IQAMAJobTitleCode: "暂住证职位代码",
    socialInsuranceStatus: "员工当地社保状态",
    ExecutionType: "执行类型",
    InjuryTime: "受伤时间",
    StopWorkingTime: "停工时间",
    Injurylocation: "受伤位置",
    HospitalName: "就医医院名称",
    DescriptionofClaimResult: "理赔结果描述",
    AttachmentAddress: "附件地址",
    FeeofGovernment: "收费标准",
    GovenmentEbankPay: "线上缴费额1",
    GovenmentEbankPay2: "线上缴费额1(SAR)",
    SADADTransferPay: "线上缴费额2",
    SADADTransferPay2: "线上缴费额2(SAR)",
    TotalOnlinePay: "线上缴费小计",
    TotalOnlinePay1: "线上缴费小计(SAR)",
    OtherCost: "其他成本",
    CosatAllocationtoApplicant: "费用分割额",
    DifferenceAmount: "费用分割与成本差额",
    SummaryDate: "汇总日期",
    Currency: "币种",
    AmountInFigure: "付款金额",
    MethodOfPayment: "付款方式",
    CompletedDate: "办结时间",
    ServiceAgreementSN: "合同编号",
    RegistrationDate: "首次注册时间",
    ContractValidity: "合同有效期",
    AgreementStatus: "合同执行状态",
    MDMSystemSN: "MDM系统编号",
    ICMSSystemSN: "ICMS系统上线编号",
    AgreementValue: "合同额",
    CRValidDate: "营业执照有效期",
    VATNO: "增值税号",
    POBoxOfficeAddress: "公司注册地址",
    AccountName: "账户名称",
    BankAddress: "银行注册地址",
    ContactName: "联络人姓名",
    Recommendby: "首次引入项目",
    OutbDate: "去程日期",
    RetFrom: "返程日期",
    DepartureDateFromEmpCtry: "工作地起飞日期",
    ArrivalDateAtEmpCtry: "工作地到达日期",
    TicketReference: "机票编号",
    OutbFrom: "去程起飞",
    OutbTo: "去程到达",
    RetFrom: "返程起飞",
    RetTo: "返程到达",
    AirlineCode: "航司信息",
    TicketIssueDate: "出票日期",
    ticketStatus: "机票状态",
    DropoffProj: "送站项目",
    DropoffSubProj: "送站分项目",
    DropoffUnit: "送站单位",
    DropoffDate: "送站日期",
    FlightNumber: "航班号",
    PickupProj: "接站项目",
    PickupSubProj: "接站分项目",
    PickupUnit: "接站单位",
    PickupDate: "接站日期",
    ticketCost: "机票费用(RMB)",
    ticketCost1: "机票费用",
    TicketFareWithoutVATSR: "税前费用(SR)",
    TicketFareWithoutVAT1: "税前费用",
    TicketFareVATSR: "Ticket Fare VAT SR",
    TicketFareVATSR1: "Ticket Fare VAT",
    DividingAmount: "分割项目费用",
    PaymentDate: "付款日期",
    PaymentStatus: "付款状态",
    VATAmount: "税费",
    AmountOfAllocation: "分割金额",
    IncomeAmount: "收益差额",
    CostCategory: "费用类型",
    SubCostCategoryName: "费用类型子项",
    CRNumberofBeneficiary: "收款单位营业执照",
    CurrencyName: "费用单位",
    AmountinWord: "费用金额大写",
    QtySum: "总数量",
    AmountSum: "总金额",
    Duration: "申请期间",
    AirTicketRoute: "航线",
    AmountofIssued: "机票数量",
    AmountofRescheduled: "改票数量",
    PercentageofRescheduled: "改票数量占比",
    InvoiceofRescheduled: "改票费用",
    PercentageofChangeFee: "改票费用占比",
    Urgent: "急件数量",
    PercentageofUrgent: "急件数量占比",
    InvoiceofIssued: "费用合计",
    Under20Days: "提报时间不足20天数量",
    PercentageofUnder20Days: "提报时间不足20天数量占比",
    Under10Days: "提报时间不足10天数量",
    PercentageofUnder10Days: "提报时间不足10天数量占比",
    OutSafeTrain: "培训状态",
    OutSafeTrainStartTime: "培训日期",
    OutSafeTrainEndTime: "证书有效期",
    Place: "培训地点",
    Timetable: "培训班期名称",
    CertificateNumber: "证书编号",
    ScheduleDate: "培训班期",
    InsuranceStatus: "保险状态",
    InsuranceCoverageStartsOn: "保险责任开始日期",
    InsuranceCoverageEndDate: "保险责任结束日期",
    ActionTypeName: "保险操作类别",
    PolicyNumber: "保单号",
    InsuranceCompany: "保险公司名称",
    ChannelTypeName: "投保类型",
    PlaceOfAccidentL: "出险地点",
    AccidentLType: "出险类型",
    AccidentLTime: "出险时间",
    ClaimStatus: "理赔状态",
    ClaimAmount: "理赔金额",
    ClaimSettlementResult: "理赔结果",
    PhysicalExaminationCategory: "体检项目类别",
    PhysicalExaminationValueCategory: "体检值类别",
    Minimum: "最小值",
    Maximum: "最大值",
    PhysicalExaminationTime: "体检时间",
    Height: "身高",
    Weight: "体重",
    WaistCircumference: "腰围",
    BloodOxygen: "血氧",
    HeartRate: "心率",
    BloodPressure: "血压",
    BloodDiastolicPressure: "舒张压",
    BloodSystolicPressure: " 收缩压",
    BloodGlucose: "血糖",
    Fasting: "空腹",
    AfterMeal: "餐后",
    BloodLipids: "血脂",
    TotalCholesterol: "总胆固醇",
    Triglyceride: "甘油三酯",
    HighDensityLipoproteinCholesterol: "高密度脂蛋白胆固醇",
    LowDensityLipoproteinCholesterol: "低密度脂蛋白胆固醇",
    EmploymentNature: "用工性质",
    SentToCountryRegion: "派往国家（地区）",
    SentToOverseasInstitutionsProjects: "派往境外机构/项目",
    BillNo: "请购单编号",
    BillDate: "请购日期",
    SNEMECProjectSNEMEC: "中东公司/项目",
    UnitDepartment: "单位/需用部门",
    AuxiliaryMaterial: "辅助物资",
    SafetyMaterial: "安全物资",
    OfficeMaterial: "内需物资",
    RequestPeriod: "需求周期",
    MaterialType: "物资类型",
    WhetherToTransfer: "是否转账",
    Uniform: "工作服",
    UniformFRC: "防火服",
    SafetyShoes: "劳保鞋",
    SafetyHelmet: "安全帽",
    Others: "其它",
    OthersQty: "其它数量",
    CostSubCategory: "费用子项",
    DescriptionsOfCost: "费用具体描述",
    ShortProjectName: "项目简称",
    Qties: "人数",
    ActualCost: "实际成本",
    DifferenceProfits: "差额（收入）",
    unitProject: "单位/项目",
    StatisticalPeriod: "统计周期",
    AverageNumberOfPeopl1: "平均人数(自有)",
    AverageNumberOfPeopl2: "平均人数(国内外包)",
    AverageNumberOfPeopl3: "平均人数(当地外包)",
    SalaryOfChineseContractEmployees: "中国籍合同制员工薪酬",
    SalaryOfDirectlyEmployedChineseStaff: "中国籍直聘员工薪酬",
    SalaryOfSaudiEmployees: "沙特籍员工薪酬",
    SalaryOfEmployeesWithThirdNationality: "第三国籍员工薪酬",
    DomesticInsuranceAndAdditionalBenefitsForChineseContractEmployees:
      "中国籍合同制员工国内保险及附加",
    ServicePeriodEndAward: "服务期结束奖",
    OtherLaborCosts: "其他人工成本(检测/劳保)",
    LaborCost: "人工成本",
    CostOfOutsourcedPersonnelForChinesePositions: "中国籍岗位外包人员费用",
    LocalJobOutsourcingCost: "当地岗位外包费用",
    PositionOutsourcingFee: "岗位外包费",
    OverseasSubsidyDesignBonus: "出国补助/设计奖金",
    SaudiCosts: "沙化成本",
    ForeignAffairsCosts: "外事费用",
    PublicSafetyCosts: "公共安全费用",
    IsolationCost: "隔离费用",
    SubcontractingCost: "分包费用",
    SubcontractingIncome: "分包收入",
    TotalCost: "成本合计",
    ServicePeriodEndAward: "服务期结束奖(预提)",
    SaudiIncome: "沙化收入(返款/奖励)",
    ForeignAffairsIncome: "外事收入(管理费计提)",
    TicketRevenue: "票务收入(管理费计提)",
    LaborIncome: "劳务收入(借工费或管理费)",
    OtherIncome: "其他收入",
    TotalRevenue: "收入合计",
    NameOfCostAnalysisIndicator: "费用分析指标名称",
    AnalyticalMetrics: "分析指标",
    ProfessionOnIQAMA: "职业类别",
    WhetherToPrintTheOccupationCategory: "职业类别是否打印",
    IsThePositionPrinted: "岗位是否打印",
    TotalSalary: "总工资",
    DateOfDeparture1: "离职日期",
    RemittanceMustBeAccompaniedByANoteSpecifying: "汇款须附言注明",
    Modifier: "修改人",
    modificationTime: "修改时间",
    OperationCategory: "操作类别",
    MessageContent: "消息内容",
    ClientIP: "客户端IP",
    BrowserType: "浏览器类型",
    OperationDate: "操作日期",
    LogCategory: "日志类别",
    OperatingSystem: "操作系统",
    BrowserVersion: "浏览器版本",
    specificDescription: "具体描述",
    ModuleID: "模块ID",
    DuringTheLogPeriod: "日志期间",
    ItemDescription: "事项描述",
    EPIProjectCode: "项目EPI编码",
    ResponsibleUnit: "负责单位",
    ProjectLocation: "项目所在地",
    PlannedCompletionDate: "计划竣工日期",
    ProjectTypeCashIn: "项目类型-兑现",
    InitialLevelRedemption: "初始级别-兑现",
    OwnersName: "业主名称",
    PartyA: "甲方名称",
    IsItIndependentAndOpenToTheOutsideWorld: "是否独立对外",
    IsItAnEmergingBusiness: "是否新兴业务",
    IsItAnEmergingMarket: "是否新兴市场",
    IsItAConsortiumProject: "是否联合体项目",
    ProjectContractAmount: "项目合同(结算)额",
    NetOutputValueOfTheProject: "项目净产值(不含设计)",
    SuperiorProjectDepartment: "上级项目部",
    ProjectDescription: "项目描述",
    NatureOfBusiness: "企业性质",
    SuperiorUnit: "上级单位",
    SuperiorDepartment: "上级部门",
    UploadTheManual: "上传说明书",
    OrganizationType: "组织类型",
    Organization: "组织",
    SuperiorOrganization: "上级组织",
    Description: "描述",
    ProjectDepartment: "所属项目部",
    AffiliatedInstitution: "所属单位",
    AffiliatedDepartment: "所属部门",
    RecruitmentProgress: "招聘进展",
    RecruitmentStatus: "招聘状态",
    TemplateFile: "模板文件",
    UploadAttachment: "上传附件",
    ApprovalForm: "审批表",
    AttendanceMonth: "考勤月份",
    WorkingDays: "工作天数",
    AverageDailyWorkingHours: "日均工时数",
    numberOfUsers: "使用人数",
    Qualification: "资质",
    DynamicAdjustmentOfDaysInTheVacationCycle: "休假周期动态调整天数",
    ReasonForApplication: "申请原因",
    TypeOfItinerary: "行程类型",
    Category: "类别",
    Quantity: "数量",
    UsageReturnDate: "使用/退还日期",
    AvailableQuantity: "可用数量",
    Validity: "有效期",
    Attachment: "附件",
    lengthOfStay: "停留天数",
    AutomaticExtraction: "自动提取",
    VisaUpload: "签证上传",
    CancelWarning: "取消预警",
    OverseasPublicSecurityTraining: "境外公共安全培训",
    EmployeeHealthAssessment: "员工健康评估",
    ApprovalOfExternalAssignmentSystem: "外派系统审批",
    ApprovalDocumentForOverseasMission: "出国任务批件",
    VisaApprovalForm: "签证审批表",
    InternationalCertificateOfVaccination: "疫苗接种国际证书",
    PhysicalExaminationStatus: "体检状态",
    NoCriminalDoubleAuthentication: "无犯罪双认证",
    CompletionTimeOfMaterialCollection: "材料收集情况完成时间",
    VisaProcessingCompletionTime: "签证办理完成时间",
    BusinessStatus: "业务状态",
    VisitTimeAndDurationOfStay: "出访时间及停留天数（含路程）",
    ApplicationDateOfApprovalDocumentForOverseasMission: "出国任务批件申请日期",
    ApplicationStatus: "申请状态",
    PhotocopyOfPassport: "护照复印件",
    PhotocopyOfIQAMA: "IQAMA印件",
    bankStatement: "银行流水",
    digitalPhoto: "电子照片",
    hardCopyPhoto: "硬拷贝照片",
    OtherMaterials1: "其他资料1",
    OtherMaterials2: "其他资料2",
    OtherMaterials3: "其他资料3",
    SubmissionTimeOfVisaMaterials: "签证材料提交时间",
    EmbassyInterviewTime: "大使馆面试时间",
    VisaCompletionTime: "签证完成时间",
    VisaNumber: "签证号",
    WhetherToUse: "是否使用",
    DepartureTime: "出发时间",
    ReturnTime: "返回时间",
    Reason: "原因",
    ProposedAdjustmentLevel: "拟调整等级",
    healthInsuranceCompany: "医保公司",
    MedicalInsuranceCost: "医保成本",
    surrenderCharge: "退保费用",
    NumberOfFamilyMembers: "家属人数",
    NumberOfWives: "妻子人数",
    NumberOfChildren: "子女人数",
    transportationAllowance: "交通补贴",
    GOSIStandardForeign: "GOSI标准-外籍",
    GOSIDeductionCoefficient: "GOSI扣减系数",
    OtherIncome: "其他收益",
    Custodian: "保管单位",
    lendTime: "借出时间",
    returnTime: "归还时间",
    CertificateCustodianUnit: "证件保管单位",
    IdNumber: "证件号",
    HandoverDate: "移交日期",
    Recipient: "接收人",
    Deliverer: "交付人",
    Recipient2: "接收人2",
    Deliverer2: "交付人2",
    InStock: "是否在库",
    ReturnDate: "交还日期",
    DoYouWantToPurchaseSOSService: "是否购买SOS服务",
    ParentExpenseItem: "上级费用项目",
    paymentMonth: "支付月份",
    paymentYear: "支付年份",
    SendTime: "发送时间",
    WhetherToview: "是否查看",
    Urgent1: "加急",
    RegularType: "普通",
    Total: "合计",
    Month: "月份",
    projectUnit: "项目/单位",
    IssueNewIqama: "暂住证新办",
    RenewIqama: "暂住证延期",
    SingleExitReentryVisa: "单次往返签证",
    MultipleExitReentryVisa: "多次往返签证",
    ExtendExitReentryVisa: "往返签证延期",
    IssueBusniessVisitVisa: "商务访签办理",
    BusniessVisitVisaExtension: "商务访签延期",
    IssueWorkingVisitVisa: "工作访签办理",
    WrokingVisitVisaExtension: "工作访签延期",
    IssueTemporaryWorkingVisa: "临时工作签证办理",
    TemporaryWrokingVisaExtension: "临时工作签证延期",
    TransferOfSponsorship: "更换签证担保单位",
    IssueVisitNonWorkingCountry: "第三国签证",
    UpdatePassport: "护照信息更新",
    CancelIQAMA: "暂住证注销",
    IssueExitVisa: "离境签证办理",
    CcancelExitVisa: "离境签证注销",
    ChangeIQAMAProfessionIQAMA: "更改职位",
    CancelExitReentry: "往返签证注销",
    IssueNewDrivingLicense: "驾照新办",
    RenewDrivingLicense: "驾照延期",
    OtherPayment: "其他付费",
    EvaluationDate: "考核日期",
    AssessmentResults: "考核结果",
    SupplierAbbreviationName: "单位名称缩写",
    ContractRenewalTimes: "合同续签次数序号",
    ValidDateOfRenwalAagreement: "新合同有效期",
    ConversationDate: "约谈时间",
    ReasonForConversation: "约谈原因",
    ResultRecord: "结果记录",
    FileName: "文件名称",
    CheckDate: "检查日期",
    CheckUnit: "检查单位",
    CheckDetails: "检查详情/症状",
    CheckResult: "检查结果",
    MedicalMeasures: "医疗措施",
    CertificateNO: "证书号",
    TraadeName: "公司名称",
    NOOfEstablishment: "公司代码",
    IssuanceGovSystem: "签发系统",
    QualificationsCertificates: "资质证书",
    DateOfIssueHijri: "签发日期(伊)",
    ValidDateHijri: "有效日期(伊)",
    FixedOvertimeWage: "固定加班工资",
    nation: "民族",
    PlaceOfOrigin: "籍贯",
    City: "户口所在地",
    PersonnelLocation: "人员所在地信息",
    Address: "常住地址",
    domesticPhone: "国内电话",
    localPhone: "当地电话",
    personalEmail: "个人邮箱",
    WorkEmail: "公司邮箱",
    MaritalStatus: "婚姻情况",
    HighestEducation: "最高学历",
    HighestDegree: "最高学位",
    HighEduTime: "毕业时间",
    JoinWorkTime: "参加工作时间",
    Specialities: "所学专业",
    Politics: "政治面貌",
    EmergencyContact: "紧急联系人",
    RelationshipWithMyself: "与本人的关系",
    EmergencyContactPhone: "紧急联系人电话",
    Language1: "掌握语种",
    LanguageLevel1: "语言能力",
    ForeignAffairsInformation: "外事信息",
    ContactInformation: "联系方式",
    RelatedTags: "相关标签",
    BasicInformation: "基础信息",
    QQ: "社交软件",
    UserID: "用户ID",
    Company: "公司",
    PositionNature: "职位性质",
    PositionHierarchy: "职位层级",
    PositionName2022: "2022年职位名称",
    CostAccumulations: "成本归集",
    ContractUnit: "合同单位",
    Employer: "雇主",
    JoinUnitTime: "加入单位时间",
    LastestInKsaDate: "最近进入沙特日期",
    FirstTimeInKsa: "首次进入沙特时间",
    LastestInUaeDate: "最近进入阿联酋日期",
    FirstTimeInUae: "首次进入阿联酋时间",
    ProfessionalQualification: "专业资格",
    QualificationDate: "资格日期",
    SkillLevel: "技能等级",
    SkillCertDate: "技能证书日期",
    CertificateName: "证书名称",
    ExpiryDate: "过期日期",
    CertificateType: "证书类型",
    Guarantor: "担保人",
    EntryVisaType: "入境签证类型",
    OverseasWorkExperience: "海外工作经验",
    LatestDemobilizationInformation: "最新解雇信息",
    AccountNameCHS: "账户中文名称",
    AccountNameEN: "账户英文名称",
    ACCOUNTNo: "账户号码",
    IBANNo: "IBAN号码",
    LocalBankName: "本地银行名称",
    RegisterPhone: "注册电话",
    RegisterSalary: "注册工资",
    EffectiveDate: "生效日期",
    AttendanceMode: "考勤模式",
    UniformSize: "制服尺寸",
    PantsSize: "裤子尺寸",
    ShoeSize: "鞋子尺寸",
    BloodType: "血型",
    VaccinationStatus: "疫苗接种状态",
    CurrentDiseases: "当前疾病",
    Medications: "药物",
    DrugAllergies: "药物过敏",
    PastMedicalHistory: "过往病史",
    FamilyMedicalHistory: "家族病史",
    issuingAuthorityName: "发证机构",
    EmploymentHistory: "任职情况",
    JobSequence: "职位序列",
    JobTitle: "职位名称",
    SigningUnitOfEmploymentAgreement: "用工协议签署单位",
    ProhibitedList: "禁止名单",
    JoinUnitTime: "进入本单位时间",
    DepartureDateOverseas: "离开本单位时间",
    LastestInKsaDate: "入沙工作时间",
    FirstTimeInKsa: "首次入沙时间",
    LastestOutKsaDate: "自沙特撤离时间",
    LastestInUaeDate: "入阿工作时间",
    FirstTimeInUae: "首次入阿时间",
    LastestOutUaeDate: "自阿联酋撤离时间",
    ProfessionalTitlesName: "专业技术资格名称",
    GetTime: "职称取得时间",
    VocationalSkillLevelName: "职业技能等级",
    DateofSkill: "技能鉴定取得时间",
    IssuedDate: "发证日期",
    ExpiryDate1: "有效期限",
    PerformanceReviewCycle: "绩效评估周期",
    ExaminationResult: "评估结果",
    AccountNameCHS1: "当地工资卡-开户中文姓名",
    AccountNameEN1: "开户英文姓名",
    ACCOUNNo: "银行卡号(ACCOUNT NO.)",
    IBANNo: "国际银行账号(IBAN NO.)",
    BankName1: "当地工资卡开户行",
    BankCode1: "银行识别码(BANK CODE)",
    RegisterPhone1: "注册手机号",
    RegisterSalary1: "注册薪资水平",
    BaseSalary: "基本薪酬",
    RetainSalary: "保留工资",
    HousingSubsidyStandards: "住房补贴标准",
    OtherDomesticSubsidies: "国内其他津补贴",
    MinimumWageStandardForEnterprisesInNanjingMonthly:
      "南京市企业最低工资标准(月)",
    HighTechSkillsAllowance: "高技术(技能)津贴",
    rentSubsidies: "房租补贴",
    OvertimeDailyWage: "加班日工资",
    AddSomeStandards: "加点标准",
    OverseasWorkAllowance: "海外工作补贴",
    TeamLeaderAllowance: "组(伙)长津贴",
    HardshipAllowanceCoefficient: "艰苦补贴系数",
    HardshipSubsidyBase: "艰苦补贴基数",
    PerformanceBonusProportionalStandard: "绩效奖金-比例标准",
    PerformanceBonusFixedUnitPrice: "绩效奖金-定额单价",
    JobSubsidyStandard: "岗位补贴标准",
    RegionalSubsidyStandards: "地区补贴标准",
    SubsidyStandardsForFieldWork: "野外工作补贴标准",
    InsuranceAllowance: "保险津贴",
    HolidayOvertimePayStandard: "假日加班工资标准",
    StandardForHolidayOvertimePay: "节日加班工资标准",
    BasicSalaryGOSIRegistration: "基本工资-GOSI注册",
    HousingSubsidyRegistration: "住房补贴-注册",
    BasicSalaryStandardForeignNationals: "基本工资标准-外籍",
    AccommodationAndMealSubsidyStandardsForeignNationals: "食宿补贴标准-外籍",
    TransportationSubsidyStandardsForeignNationals: "交通补贴标准-外籍",
    MedicalSubsidyStandardsForeignNationals: "医疗补贴标准-外籍",
    WorkExperienceSubsidyStandardsForeignNationals: "工龄补贴标准-外籍",
    PerformanceBonusStandardsForeignNationals: "绩效奖金标准-外籍",
    TwoHourSubsidyForeignNationals: "两小时补助-外籍",
    GOSIStandardForeignNationals: "GOSI标准-外籍",
    GOSIDeductionCoefficient: "GOSI扣减系数",
    OutSafeTrainStatus: "境外公共安全培训情况",
    OutSafeTrainValidity: "境外公共安全培训有效期",
    JoinInsuranceStatus: "境外人身意外伤害保险",
    JoinInsuranceEndTime: "境外人保有效期",
    MedicalInsuranceStatus: "当地医疗保险",
    MedicalInsuranceEndTime: "当地医保有效期",
    MedicalInsuranceClassLevel: "当地医保等级",
    SocialInsuranceStatus: "当地社会保险",
    SocialInsuranceEndTime: "当地社保有效期",
    SocialInsuranceClassLevel: "当地社保等级",
    OverseasWorkExperience: "过往海外工作经历",
    LatestDemobilizationInformation: "最近一次海外撤离记录",
    EventType: "事件类别",
    ChangeDate: "变更日期",
    GoAbroadDate: "赴海外日期",
    AdjustDate: "调整日期",
    EmployeeInfoType: "员工信息类别",
    EmployeeInfoSubType: "员工信息子类别",
    OldValue: "旧值",
    NewValue: "新值",
    BackupDate: "备份日期",
    CostAggregation: "费用归集",
    CostCategory1: "费用大项",
    CostSubCategory1: "费用子项",
    CostCategoryDetail: "费用细项",
    ImportBasicInformation: "导入基础信息",
    ImportWorkInformation: "导入工作信息",
    Year: "年份",
    week: "周数",
    Type: "类别",
    SNEILocalLaborServices: "SNEI/当地劳务",
    DomesticLocalLaborServices: "国内分包/当地劳务",
    LocalSubcontractingChineseEmployee: "当地分包/中国籍员工",
    LocalSubcontractingThirdStateEmployee: "当地分包/第三国籍员工",
    LocalSubcontractingLocalEmployees: "当地分包/当地员工",
    InternalIn: "内部借入",
    InternalOut: "内部借出",
    ExternalIn: "外部借入",
    ExternalOut: "外部借出",
    InternalInRemarks: "内部借工简述",
    ExternalInRemarks: "外部借工简述",
    LocalLaborServices: "当地劳务",
    DomesticSubcontracting: "国内分包",
    LocalSubcontracting: "当地分包",
    NumberOfnonSinopecvisaholders: "(非中石化签证人员数量)",
    ChineseEmployee: "中国籍员工",
    ThirdStateEmployee: "第三国籍员工",
    LocalEmployees: "当地员工",
    RouteType: "航线类型",
    ProductTime: "生成时间",
    AdjustedYears: "折算后工龄",
    CumulativeYears: "累计工龄",
    whetherHotspot: "是否热点",
    whetherPinToTop: "是否置顶",
    MessageDetails: "消息详细内容",
    GovernmentPlatform: "政府平台",
    Registrant: "注册人",
    AuthorizationDepartment: "隶属部门",
    AnnualFeeofGovSystem: "政府系统年费",
    RegisteredEmail: "注册邮箱",
    LoginOTPMobileNO: "验证手机号",
    WebsiteAddress: "网址",
    DescriptionofFunction: "系统用途",
    LoginPassword: "密码",
    WorkInformation: "工作信息",
    QualificationAbility: "资格能力",
    BankAccount: "银行账户",
    SalaryStandard: "薪酬信息",
    StaffPhoto: "员工照片",
    dateRecordedStatus: "是否录入",
    DepartureDateOverseas: "离开南工境外单位时间",
    CyclicYear: "周期年份",
    CountryStatyDurationTimes: "国家/停留时长/次数",
    PreviousSponsorVisaTypeDemobilizationDate: "原Sponsor/签证类型/撤离时间",
    DrugContraindications: "药物禁忌",
    Pulse: "脉搏(次/分钟)",
    OrganExamination: "器官检查",
    PhysicalCharacteristics: "身体特征",
    NervousSystem: "神经系统",
    LaboratoryTests: "实验室检查",
    Vaccination: "疫苗接种",
    MedicationStatus: "服用药物情况",
    PastMedicalHistory: "既往病史",
    DiseaseList: "疾病列表",
    Hypertension: "高血压",
    Hyperlipidemia: "高血脂",
    Hyperglycemia: "高血糖",
    HeartDisease: "心脏病",
    Diabetes: "糖尿病",
    Bronchitis: "支气管炎",
    GastrointestinalDisease: "肠胃病",
    othersymptom: "其他（症状：",
    Indicator: "指标",
    FamilyMedicalHistoryList: "家族病史列表",
    CoronaryHeartDisease: "冠心病",
    CerebrovascularDisease: "脑血管病",
    MalignantTumor: "恶性肿瘤",
    otherJB: "其他",
    Father: "父亲",
    Mother: "母亲",
    MaterialName: "物料名称",
    UnitJL: "计量单位",
    DeliveryTime: "要求到货时间",
    ModelSpecification: "规格型号",
    Percentage: "比例",
    OvertimeDate: "加班日期",
    DescriptionOfOvertimeWork: "加班工作内容描述",
    EmployeeTypeName: "员工类型",
    EmployeeCategoryName: "员工类别",
    DateofDeparture: "出国日期",
    ReturnDate: "回国日期",
    VisaNature: "签证性质",
    SettlementType: "结算模式",
    JobProfession: "借工人员工种/岗位",
    Qualif: "人员资质",
    QtyJG: "借工数量",
    Rate: "借工单价",
    FATBearedBy: "食宿交通提供方",
    RateofOverheadFee: "管理费比例",
    CertificateLevel: "证书等级",
    DateOfIssueQZ: "取证年限",
    NameOfManpowerSupplier: "岗位服务外包单位名称",
    DateOfVerification: "核实日期",
    ResultOfverification: "核实结果",
    ItemsofVerification: "核查项目",
    CourseContent: "培训主题/内容",
    LastUpdateTime: "最后更新时间",
  },

  //短名词
  shortNoun: {
    OrganizationalStructureChart: "组织架构图",
    create: "新建",
    query: "查询",
    export: "导出",
    import: "导入",
    FirstImport: "首次导入",
    transfer: "转办",
    FeeUpdate: "费用更新",
    Update: "更新",
    costConfirmation: "费用确认",
    costSummary: "费用汇总",
    addOtherPayments: "添加其它付费",
    approvalFormAddition: "添加审批表",
    maintenanceEntity: "维护主体",
    statistics: "统计",
    batchSetSuperior: "批量设置上级",
    batchRelease: "批量发布",
    displayChart: "显示图表",
    usageHistory: "使用记录",
    bonusPage: "奖金页面",
    domesticDistribution: "国内发放",
    homePage: "首页",
    workbench: "工作台",
    workPlatform: "工作平台",
    employeeCenter: "员工中心",
    managementCenter: "管理中心",
    commonFunctions: "常用申请",
    approvalMatters: "审批事项",
    commonTemplate: "常用模版",
    notice: "通知公告",
    reference: "待我查阅",
    flightItinerary: "机票行程",
    information: "资料",
    logOut: "注销",
    management: "管理",
    more: "更多",
    hello: "您好",
    lastLoginTime: "上次登录时间",
    CCItems: "抄送事项",
    myMessage: "我的消息",
    personalInformation: "个人信息",
    foreignAffairs: "外事业务",
    personnelAffairs: "人事业务",
    myDocuments: "我的证件",
    otherApplications: "其它应用",
    toDo: "待办事项",
    completedTasks: "已办事项",
    returned: "被退回",
    ended: "办结",
    seeOffInformation: "送站信息",
    pickUpInformation: "接站信息",
    itemName: "事项名称",
    nodeLocation: "所在节点",
    submissionTime: "送审时间",
    retentionTime: "滞留时间",
    message: "消息",
    pendingReview: "审批中",
    reject: "驳回",
    approved: "已通过",
    select: "选择...",
    save: "保存",
    Cancel: "取消",
    Close: "关闭",
    Release: "发布",
    LoginAccount: "登录账号",
    AccountPassword: "账号密码",
    Code: "验证码",
    Login: "登录",
    centre: "中",
    MessageTitle: "消息标题",
    MessageType: "选择类型",
    IncreaseStaff: "增加人员",
    MessageContent: "消息内容",
    download: "下载",
    product: "生成",
    NotPploaded: "未上传",
    downloadAttachment: "下载附件",
    menuID: "菜单ID",
    menuName: "菜单名称",
    ParentID: "父级ID",
    serialNumber: "排序号",
    moduleCode: "模块代码",
    moduleType: "模块类型",
    HomepageShortcuts: "是否首页快捷方式",
    PermissionButton: "权限按钮",
    ShortcutIcon: "快捷方式图标",
    AddChildLevel: "添加子级",
    AddSibling: "添加同级",
    DeleteMenu: "删除菜单",
    AttachmentType: "附件类型",
    Approval: "审批",
    Pass: "通过",
    Refuse: "拒绝",
    Reject: "驳回",
    Account: "账号",
    OldPassword: "原密码",
    NewPassword: "新密码",
    ConfirmedPassword: "确认密码",
  },

  //提示
  placeholder: {
    input: "请输入",
    select: "请选择",
    date: "选择日期",
    year: "选择年",
    moon: "选择月",
    startDate: "开始日期",
    endDate: "结束日期",
    to: "至",
    name: "请输入菜单名称...",
    search: "搜索",
    langName:
      "身体特征(面部特征/皮肤/巩膜/淋巴结/头部/颈部/脊柱和四肢 视力/听力)",
  },

  //弹框提示词
  prompt: {
    title1: "新建成功",
    title2: "编辑成功",
    title3: "删除成功",
    title4: "此操作将永久删除该数据, 是否继续?",
    title5: "导入成功",
    title6: "保存成功",
    title7: "付费成功",
    title8: "办结成功",
    title9: "审批成功",
    title10: "转办成功",
    title11: "设置成功",
    title12: "费用确认完成",
    title13: "费用汇总完成",
    title14: "发布成功",
    title15: "是否加入机票购买",
    title16: "加入机票购买成功",
    title17: "确认提交当前审批单, 是否继续?",
    title18: "添加审批表成功",
    title19: "附件上传成功",
    title20: "连接成功",
    title21: "该选项下不存在成本中心，请重新选择",
    title22: "费用主体不能为空",
    title23: "暂未开发!",
    title24: "员工编号不存在",
    title25: "本月未更新!",
    title26: "离沙日期必须大于入沙日期",
    title27: "请上传人简历和资质证书",
    title28: "所属项目名称不一致",
    title29: "所属分项目名称不一致",
    title30: "所属用工单位不一致",
    title31: "所属部门信息不一致",
    title32: "所属当地雇主不一致",
    title33: "工作地起飞日期必须小于工作地到达日期",
    title34: "工作签,需上传护照、身份证、健康疫苗证",
    title35: "年龄大于60,需上传超龄审批附件",
    title36: "访问签,需上传护照附件",
    title37: "登录账号不能为空",
    title38: "账号密码不能为空",
    title39: "验证码不能为空",
    title40: "ID只能输入纯数字",
    title41: "请先选择外事关系",
    title42: "请先选择审批状态",
    title43: "同意状态不能为空,请先选择是否同意",
    title44: "含有不同意选择，审核状态不能选择通过",
    title45: "请选择起飞城市",
    title46: "请选择到达城市",
    title47: "请选择航线类别",
    title48: "请至少选中一行数据",
    title49: "数据中存在已确认数据，请取消",
    title50: "费用确认后不再允许修改，是否确认费用？",
    title51: "数据中存在已汇总数据，请取消",
    title52: "数据中存在费用未确认数据，请取消",
    title53: "添加审批表时只能选中一条数据！",
    title54: "请选择流程",
    title55: "没有更多了",
    title56: "请先选择辖区外任务",
    title57: "选中数据存在费用期间不一致",
    title58: "选中数据存在收款单位不一致",
    title59: "选中数据存在当地雇主不一致",
    title60: "不支持流程结束节点作为连线起点",
    title61: "不支持流程开始作为连线终点",
    title62: "节点不支持连接自己",
    title63: "该关系已存在,不允许重复创建",
    title64: "不支持两个节点之间连线回环",
    title65: "【流程开始】节点已存在,只能选择一个流程开始节点",
    title66: "【流程结束】节点已存在,只能选择一个流程结束节点",
    title67: "请把节点拖入到画布中",
    title68: "流程名称不能为空",
    title69: "请选择左侧流程实例",
    title70: "请至少选择一个流程节点",
    title71: "只能上传后缀为jpg、png、jpeg、pdf、xls、xlsx、rar、zip的文件!",
    title72: "开始日期不能小于当前日期",
    title73: "开始日期不能大于或等于结束日期",
    title74: "只能上传后缀为xls、xlsx的文件!",
    title75: "只能上传后缀为pdf的文件!",
    title76: "只能上传后缀为jpg、png、jpeg、pdf、xls、xlsx的文件!",
    title77: "只能上传后缀为jpg、png、jpeg、pdf的文件!",
    title78: "只能上传后缀为jpg、jpeg、png的文件!",
    title79: "只能上传后缀为pnf、docx、png、jpg、gif的文件!",
    title80: "请先选中角色列表",
    title81: "请选择节点",
    title82: "上级组织机构不能为自己",
    title83: "可用数量小于0,数据错误,请检查数据",
    title84: "确定删除所点击的线吗?",
    title85: "确定要删除节点",
    title86: "此操作是付费操作, 是否继续?",
    title87: "此操作是办结操作, 是否继续?",
    title88: "机票可能选择错误，确认提交吗?",
    title89: "请前往协同办公系统处理?",
    title90: "此操作将永久删除该数据(及其子项), 是否继续?",
    title91:
      "删除后，会同时删除对应的付款通知单、分割单以及审批单。是否确认删除?",
    title92: "选中数据存在票务代理不一致",
    title93: "是否需申请机票",
    title94: "生成成功",
    title95: "第一阶段信息已录入系统；请及时录入员工其他信息。",
    title96: "接送站信息日期和时间不完整",
    title97: "请先修改密码!",
  },
};
